/**
 * Project Storage Service
 * Handles project-specific storage operations
 */

import type { GatewayClient } from './client'
import type { ProjectStorageInfo } from './types'

export interface ProjectStorageService {
  /**
   * Get storage status for the project
   */
  getStatus(): Promise<ProjectStorageInfo>
}

/**
 * Options for creating a project storage service
 */
export interface ProjectStorageOptions {
  projectId: string
}

/**
 * Create a ProjectStorageService instance
 */
export function createProjectStorageService(
  client: GatewayClient,
  options: ProjectStorageOptions
): ProjectStorageService {
  const { projectId } = options

  return {
    async getStatus(): Promise<ProjectStorageInfo> {
      return client.get<ProjectStorageInfo>(`/v1/projects/${projectId}/storage`)
    },
  }
}
